import React from "react";
import "./Home.css";

export const Accommodation = () => {
  return (
    <>
      <div className="page-layout">
        <div className="text-layout">
          <h2>Accommodation</h2>
          <h3>Conference Rated Accommodation</h3>
          <br />
          <h4>The Kingsley Hotel</h4>
          <p>
            The Kingsley Hotel is located roughly five minutes from the{" "}
            <a href="https://www.cs.ucc.ie/smartcomp2025/#/venue">
              Western Gateway Building, UCC
            </a>
            , walking. This is the venue of the conference from 17th to 19th
            June.
          </p>

          <p>
            The 220 bus can be used to get to MTU campus for the workshops on
            16th June. There is a stop outside of the Western Gateway Building.
          </p>
          <p style={{ fontWeight: "bold" }}>Conference Rate: </p>
          <ul>
            <li>€200.00 B&B per classic single room per night </li>
            <li>€220.00 B&B per classic double/twin room per </li>
          </ul>
          <br />
          <p style={{ fontWeight: "bold" }}>To Book: </p>
          <p>
            Call The Kingsley on 00353 21 480 0500 or email{" "}
            <a href="mailto:reservations@thekingsley.ie">
              reservations@thekingsley.ie
            </a>{" "}
            and confirm that you will be attending the IEEE SmartComp 2025 when
            booking.
          </p>
          <p style={{ fontWeight: "bold" }}>
            Rooms are limited and are first come first served.
          </p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.2260098397874!2d-8.511055222879765!3d51.89333947190356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4844902c6a0e3137%3A0x888e5b7ac95926cf!2sThe%20Kingsley%20Hotel!5e0!3m2!1sen!2sie!4v1736335677095!5m2!1sen!2sie"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
          <br />
          <br />
          <h4>The River Lee Hotel</h4>
          <p>
            The River Lee Hotel is a 15-minute walk from the Western Gateway
            Building, UCC.
          </p>
          <p>
            The 220 bus can be used to get to MTU campus for the workshops on
            16th June. There is a stop outside of the Western Gateway Building.
          </p>
          <p style={{ fontWeight: "bold" }}>Conference Rate: </p>
          <ul>
            <li>€240.00 B&B per room per night </li>
          </ul>
          <br />
          <p style={{ fontWeight: "bold" }}>To Book: </p>
          <p>
            Attendees can book by calling the hotel on 00 353 21 4252700 or
            emailing{" "}
            <a href="mailto:cork@doylecollection.com">
              cork@doylecollection.com
            </a>{" "}
            and quoting reference UCCI150625.
          </p>
          <p style={{ fontWeight: "bold" }}>
            Rooms are limited and are first come first served. Bookings must be
            made before 21st April 2025 to avail of the conference rate.
          </p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.0841741144413!2d-8.487397922879637!3d51.895927971904364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48449024d05b5e67%3A0xb5d75fc2756df711!2sThe%20River%20Lee%20Hotel!5e0!3m2!1sen!2sie!4v1736335745721!5m2!1sen!2sie"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
          <br />
          <br />
          <h4>Victoria Mills</h4>
          <p>
            Victoria Mills is student accommodation located just two minutes
            from the Western Gateway Building on foot. All rooms are ensuite
            with a double bed and shared living space with other SmartComp
            attendees.
          </p>
          <p>
            The 220 bus can be used to get to MTU campus for the workshops on
            16th June. There is a stop outside of the Western Gateway Building.
          </p>
          <p style={{ fontWeight: "bold" }}>Conference Rate: </p>
          <ul>
            <li>€80.00 room per night </li>
          </ul>
          <br />
          <p style={{ fontWeight: "bold" }}>To Book: </p>
          <p>
            To avail of the conference rate, please visit the booking page{" "}
            <a href="https://picassoonline.techotel.dk/en/ucc/victoria-mills/booking/rooms/">
              here.
            </a>
          </p>
          <p>
            Then you will need to select the required dates, input the Campaign
            Code "IEEE Smart", and click "Search".
          </p>
          <img src="./images/misc/search.png" style={{ borderRadius: 0 }}></img>
          <p>
            This will bring up the IEEE Smart Comp Conference Self Catering Rate
            of €80 per room per night.
          </p>
          <p>
            Once the booking has been made, guests will receive a booking
            confirmation email with a link to pay.
          </p>
          <p style={{ fontWeight: "bold" }}>
            Rooms are limited and are first come first served. Bookings must be
            made by 23rd May to avail of the conference rate.
          </p>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.2577297244566!2d-8.50542512287972!3d51.89276057190348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4844902e65bdf885%3A0xa632bd4da6344a92!2sVictoria%20Mills%20-%20UCC%20Summer%20Beds!5e0!3m2!1sen!2sie!4v1736336504248!5m2!1sen!2sie"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  );
};
